<template>
  <UIModal
    :width="544"
    :zIndex="undefined"
    :to="undefined"
    :autoFocus="false"
    :maskClosable="true"
    :showBorder="false"
    :closeOnEsc="undefined"
    :show="internalShow"
    @onMaskClick="cancelCallback"
    @onEsc="cancelCallback"
    className="flex justify-center"
  >
    <template #header>
      <UIModalHeader
        :title="t('calendar_advanced.forms_payment.enable_payments_for_guests')"
        @close="cancelCallback"
        id="modal-header"
      />
    </template>

    <div class="pt-2">
      <p class="text-gray-600">
        {{ t('calendar_advanced.forms_payment.guest_payment_description') }}
      </p>

      <div class="mt-4">
        <div class="flex items-center space-x-3">
          <UICheckbox
            v-model:checked="enableChargeGuests"
            size="medium"
            :aria-label="t('calendar_advanced.forms_payment.charge_per_attendee')"
          >
            <span class="text-gray-900">
              {{ t('calendar_advanced.forms_payment.multiply_amount_guests') }}
            </span>
          </UICheckbox>
        </div>
      </div>
    </div>

    <div class="py-0">
      <UIModalFooter
        :positiveText="t('settings.calendar.save')"
        :negativeText="$t('create_calendar.cancel')"
        @positive-click="submitCallback"
        @negative-click="cancelCallback"
        :type="'primary'"
        class="!p-0"
      />
    </div>
  </UIModal>
</template>

<script setup lang="ts">
import {
  UICheckbox,
  UIModal,
  UIModalFooter,
  UIModalHeader
} from '@gohighlevel/ghl-ui'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'


const { t } = useI18n()

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
    default: false
  },
  chargeGuestsEnabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:show', 'onConfirm', 'update:chargeGuestsEnabled'])
const internalShow = ref(props.show)
const enableChargeGuests = ref(props.chargeGuestsEnabled)

watch(() => props.show, (newVal) => {
  console.log('Show prop changed:', newVal)
  internalShow.value = newVal
  // Reset checkbox value when modal is closed
  if (!newVal) {
    enableChargeGuests.value = props.chargeGuestsEnabled
  }
})

watch(() => props.chargeGuestsEnabled, (newVal) => {
  enableChargeGuests.value = newVal
})

watch(enableChargeGuests, (newVal) => {
  emit('update:chargeGuestsEnabled', newVal)
})

const cancelCallback = () => {
  // Reset the checkbox value to match parent state when closing
  enableChargeGuests.value = props.chargeGuestsEnabled
  emit('update:show', false)
}

// Method to handle the modal submit action
const submitCallback = () => {
  emit('onConfirm', enableChargeGuests.value)
  emit('update:chargeGuestsEnabled', enableChargeGuests.value)
  emit('update:show', false)
}

</script>